import { get } from '@ember/object';
import { isEmpty } from '@ember/utils';
import { validatePresence } from 'ember-changeset-validations/validators';

export default {
  label: validatePresence({ presence: true, message: "Can't be blank" }),
  originalDate: (key, newValue /*, oldValue, changes, content*/) => {
    if (newValue != null && typeof newValue.getMonth === 'function') {
      return true;
    }
    return 'Must be a date';
  },
  alertNumber: (key, newValue, oldValue, changes, content) => {
    if (enableAlert(changes, content)) {
      let numVal = Number(newValue);
      if (!isEmpty(newValue) && isNumber(numVal) && isInteger(numVal)) {
        return true;
      } else {
        return 'Must provide a number';
      }
    }
    return true;
  },
  alertUnit: (key, newValue, oldValue, changes, content) => {
    if (enableAlert(changes, content) && isEmpty(newValue)) {
      return "Can't be blank";
    }
    return true;
  },
};

function enableAlert(changes, content) {
  let changesEnableAlert = get(changes, 'enableAlert');
  if (changesEnableAlert !== undefined) {
    return changesEnableAlert;
  }
  return get(content, 'enableAlert');
}

// taken from https://github.com/offirgolan/ember-validators/blob/master/addon/number.js#L109
function isNumber(value) {
  return typeof value === 'number' && !isNaN(value);
}

function isInteger(value) {
  return (
    typeof value === 'number' && isFinite(value) && Math.floor(value) === value
  );
}
